import { FacilityType } from './facility-type';
import { FieldType } from './field-type';

export enum PlanStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum BillingCycle {
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}

export enum CommitmentType {
  ANNUAL = 'annual',
  MONTHLY = 'monthly',
}

export enum PlanType {
  GLOBAL = 'global',
  CORPORATE = 'corporate',
  RETAIL = 'retail',
  TRIAL = 'trial',
}

export enum PlanField {
  BOX_ASSESSMENT = 'box_assessment',
  ELEVATED_COACHING_SESSION = 'elevated_coaching_session',
  CUSTOMIZED_IMPROVEMENT_PLAN = 'customized_improvement_plan',
  GUEST_ACCESS_FREE_COUNT = 'guest_access_free_count',
  PAID_GUEST_ACCESS = 'paid_guest_access',
  /** Same-franchise drop-ins at locations with the flag on are free and unmetered. */
  FRANCHISE_FREE_GUEST_ACCESS = 'franchise_free_guest_access',
  NO_SHOW_WAIVER_COUNT = 'no_show_waiver_count',
  NO_SHOW_PENALTY = 'no_show_penalty',
}

export const PLAN_FIELD_TYPE_CONFIG: Record<PlanField, FieldType> = {
  [PlanField.BOX_ASSESSMENT]: FieldType.BOOLEAN,
  [PlanField.ELEVATED_COACHING_SESSION]: FieldType.BOOLEAN,
  [PlanField.CUSTOMIZED_IMPROVEMENT_PLAN]: FieldType.BOOLEAN,
  [PlanField.GUEST_ACCESS_FREE_COUNT]: FieldType.COUNT,
  [PlanField.PAID_GUEST_ACCESS]: FieldType.BOOLEAN,
  [PlanField.FRANCHISE_FREE_GUEST_ACCESS]: FieldType.BOOLEAN,
  [PlanField.NO_SHOW_WAIVER_COUNT]: FieldType.COUNT,
  [PlanField.NO_SHOW_PENALTY]: FieldType.CHARGE,
};

export interface PlanFieldData {
  value: any;
  enabled: boolean;
}

export enum DiscountType {
  PERCENTAGE = 'percentage',
  FIXED = 'fixed',
}

export interface Discount {
  amount: number;
  type: DiscountType;
}

export interface Plan {
  id: string;
  planId: string;
  name: string;
  slug: string;
  franchiseId?: string;
  locationId?: string;
  ghlProductId?: string;
  checkoutBaseUrl?: string;
  commitmentType: CommitmentType;
  paymentTerm: number;
  billingCycle: BillingCycle;
  allowedBillingCycles: BillingCycle[];
  supportedFacilities: FacilityType[];
  fields: Record<PlanField, PlanFieldData>;
  status: PlanStatus;
  planType: PlanType;
  price: number;
  minPrice: number;
  maxPrice: number;
  currency: string;
  parentId?: string;
  discount?: Discount;
  guestAccessDiscount?: Discount;
  memberCount?: number;
  isHidden?: boolean;
}

export interface PlanRequest extends Omit<
  Plan,
  'id' | 'planId' | 'slug' | 'supportedFacilities' | 'planType'
> {}
